import type { Membership, Role } from './sessionContext';

/** Área de entrada según el rol de la organización activa (espejo de las guardias de `router.tsx`). */
export function homeForRole(role: Role | undefined): string {
  if (role === 'operator') return '/operador';
  if (role === 'seller') return '/terreno';
  return '/consola';
}

/** Roles que admite cada área; se usa para elegir una membresía compatible antes de negar el acceso. */
export const AREA_ROLES: Record<string, Role[]> = {
  '/consola': ['owner', 'admin', 'editor', 'viewer'],
  '/terreno': ['seller', 'owner', 'admin'],
  '/operador': ['operator'],
};

export function membershipFor(memberships: Membership[], roles: Role[]): Membership | undefined {
  return memberships.find((m) => roles.includes(m.role));
}
